<p-dialog
  appendTo="body"
  [baseZIndex]="20000"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: editing ? '1100px' : '640px' }"
  [header]="(creating ? 'Create cadastre parcel' : 'Cadastre parcel') | translate"
  (onHide)="onHide()"
>
  <ng-template pTemplate="content">
    @if (editing) {
      <div class="cadastre-editor">
        <div class="cadastre-map">
          <mfs-old-map
            height="520px"
            [zoom]="18"
            [center]="mapCenter"
            [drawingMode]="true"
            [polygonJson]="draft.geometryJson || undefined"
            [geometry]="draft.geometryJson || ''"
            [polygonArea]="draft.area"
            [isCenterMarker]="false"
            [isSplitControl]="false"
            [fitAllSibling]="false"
            [allowDrawUnderSibling]="false"
            [showIndexControl]="false"
            [showPolygonFillToggle]="false"
            (geometryChange)="onGeometryChange($event)"
            (polygonAreaChange)="onAreaChange($event)"
            (validationError)="onValidationError($event)"
          ></mfs-old-map>

          @if (validationError) {
            <div class="validation-error">
              <i class="pi pi-exclamation-triangle"></i>
              {{ validationError }}
            </div>
          }
        </div>

        <div class="cadastre-form">
          <label>
            <span>{{ 'Cadastre' | translate }}</span>
            <input pInputText [(ngModel)]="draft.cadNumber" [readonly]="readonlyMode" />
          </label>
          <label>
            <span>{{ 'AREA' | translate }} (ha)</span>
            <p-inputNumber
              [(ngModel)]="draft.area"
              [minFractionDigits]="0"
              [maxFractionDigits]="4"
              [disabled]="readonlyMode"
            ></p-inputNumber>
          </label>
          <label>
            <span>{{ 'District SOATO' | translate }}</span>
            <input pInputText [(ngModel)]="draft.districtSoato" [readonly]="readonlyMode" />
          </label>
          <label>
            <span>{{ 'Tax number' | translate }}</span>
            <input pInputText [(ngModel)]="draft.taxNumber" [readonly]="readonlyMode" />
          </label>
          <label>
            <span>{{ 'Land type' | translate }}</span>
            <input pInputText [(ngModel)]="draft.landType" [readonly]="readonlyMode" />
          </label>
          <label>
            <span>{{ 'Address' | translate }}</span>
            <input pInputText [(ngModel)]="draft.address" [readonly]="readonlyMode" />
          </label>
        </div>
      </div>
    } @else if (parcel) {
      <div class="cadastre-details">
        <div class="detail-row">
          <span class="detail-label">{{ 'Cadastre' | translate }}:</span>
          <span class="detail-value">{{ parcel.cadNumber || '—' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'AREA' | translate }}:</span>
          <span class="detail-value">
            {{ parcel.area != null ? (parcel.area | number:'1.2-2') + ' ha' : '—' }}
          </span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'District SOATO' | translate }}:</span>
          <span class="detail-value">{{ parcel.districtSoato || '—' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'Tax number' | translate }}:</span>
          <span class="detail-value">{{ parcel.taxNumber || '—' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'Land type' | translate }}:</span>
          <span class="detail-value">{{ parcel.landType || '—' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'Address' | translate }}:</span>
          <span class="detail-value">{{ parcel.address || '—' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'Data source' | translate }}:</span>
          <span class="detail-value">{{ parcel.dataSource || '—' }}</span>
        </div>
      </div>
    }
  </ng-template>

  <ng-template pTemplate="footer">
    @if (editing && readonlyMode) {
      <button pButton type="button" class="p-button-text" [label]="'Back' | translate"
              (click)="cancelEdit()"></button>
    } @else if (crudEnabled) {
      @if (editing) {
        <button pButton type="button" class="p-button-text" [label]="'Cancel' | translate"
                [disabled]="saving" (click)="cancelEdit()"></button>
        <button pButton type="button" [label]="'Save' | translate"
                [loading]="saving"
                [disabled]="saving || !!validationError || !draft.cadNumber || !draft.geometryJson"
                (click)="saveParcel()"></button>
      } @else {
        <button pButton type="button" class="p-button-danger p-button-text"
                [label]="'Delete' | translate" [disabled]="saving" (click)="deleteParcel()"></button>
        <button pButton type="button" [label]="'Edit' | translate"
                [disabled]="saving" (click)="startEdit()"></button>
      }
    } @else {
      <button pButton type="button" [label]="'View details' | translate"
              (click)="startReadonlyView()"></button>
    }
  </ng-template>
</p-dialog>
